export default __webpack_public_path__ + "static/images/dash-logo-white.png";